<template>
  <div class="about-page" style="padding-top: 80px">
    <!-- Our Testimonials -->
    <section class="our-testimonials">
      <div class="mt-12">
        <div class="container mx-auto px-4">
          <div class="grid grid-cols-1 lg:grid-cols-2 mt-8 gap-8 md:gap-8">
            <div class="text-justify">
              <h2 class="mb-12">About Us</h2>
              <p>
                Loop Properties means infinity, union, alliance, connection,
                creating practical homes and building a unique and easy
                experience for owners and tenants. We are a real estate company,
                letting, managing properties, developing and envisioning one of
                the largest portfolios in the north of Malta.
              </p>
              <p class="mt-4">
                Darren Abela, the founder of Loop Homes, has been working in the
                property business since 1998 and was one of the pioneer property
                consultants specializing in the Northern area. This is a
                family-run business specializing in letting, property
                management, developing green homes and building strong bonds
                between owner and tenants.
              </p>
              <p class="mt-4">
                Our property consultants promote long-term success by adhering
                to a set of common values, which enables us to provide the
                highest-quality, optimal outcomes for our owners, tenants,
                business partners and communities in which we do business and
                live.
              </p>
            </div>
            <div class="div">
              <iframe
                class="w-full rounded-lg"
                height="350"
                style="border: 0"
                loading="lazy"
                allowfullscreen
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJiRGcqiRPDhMRIHzHRGEXmbc&key=AIzaSyDbHZ_PJbleeHcrNl0DmZjrENBaxE56Hvw"
              ></iframe>
            </div>
          </div>
          <div
            class="
              grid grid-cols-1
              lg:grid-cols-2
              gap-6
              md:gap-8
              my-6
              md:my-12
              people-desc
            "
          >
            <div class="flex flex-col sm:flex-row justify-center rounded-lg bg-black p-8">
              <div class="flex justify-center md:mr-8 mb-8 md:mb-0">
                <img
                  src="~@/assets/aboutus-darren-image.png"
                  alt="darren"
                  class="object-contain"
                />
              </div>
              <div class="flex flex-col justify-center text-primary-color">
                <p class="my-2">
                  Hobbies: Art Resin, Interior Design, Woodwork & Planting.
                </p>
                <p class="my-2">
                  Favorite Quote: "You should never regret anything in life. If
                  it's good, it's wonderful. If it's bad, it's an experience"
                </p>
                <p class="my-2">Birthday: 30th December</p>
                <p class="my-2 text-xs">Email: darren.abela@loophomes.com.mt</p>
              </div>
            </div>
            <div class="flex flex-col sm:flex-row justify-center rounded-lg bg-black p-8">
              <div class="flex justify-center md:mr-8 mb-8 md:mb-0">
                <img
                  src="~@/assets/aboutus-juliana-image.png"
                  alt="darren"
                  class="object-contain"
                />
              </div>
              <div class="flex flex-col justify-center text-primary-color">
                <p class="my-2">
                  Hobbies: Yoga, Mindfulness & Anything in Nature.
                </p>
                <p class="my-2">
                  Favorite Quote: "In a world where you can be anything. Be Kind!"
                </p>
                <p class="my-2">Birthday: 2nd March</p>
                <p class="my-2">Mobile: (356) 9942 6498</p>
                <p class="my-2 text-xs">Email: juliana.abela@loophomes.com.mt</p>
              </div>
            </div>
            <div class="flex flex-col sm:flex-row justify-center rounded-lg bg-black p-8">
              <div class="flex justify-center md:mr-8 mb-8 md:mb-0">
                <img
                  src="~@/assets/aboutus-evgenia-image.png"
                  alt="darren"
                  class="object-contain"
                />
              </div>
              <div class="flex flex-col justify-center text-primary-color">
                <p class="my-2">
                  Hobbies: Dancing Latin Music
                </p>
                <p class="my-2">
                  Favorite Quote: "Whatever is happening, is happening for a reason"
                </p>
                <p class="my-2">Birthday: 23rd October</p>
                <p class="my-2">Mobile: (356) 9914 8644</p>
                <p class="my-2 text-xs">Email: evgenia.cassar@loophomes.com.mt</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
img {
  min-width: 230px;
  max-width: 300px;
  width: 100%;
}
.people-desc * {
  font-family: monospace;
}
</style>
